export function drawStroke(ctx, imageData, strokeWidth) {
    const isTransparent = (x, y) => {
        const idx = (y * imageData.width + x) * 4 + 3;
        return imageData.data[idx] < 128; // Assuming alpha value less than 128 is transparent
    };

    const isEdgePixel = (x, y) => {
        if (isTransparent(x, y)) return false;
        for (let i = -1; i <= 1; i++) {
            for (let j = -1; j <= 1; j++) {
                if (i !== 0 || j !== 0) {
                    if (x + i >= 0 && x + i < imageData.width && y + j >= 0 && y + j < imageData.height) {
                        if (isTransparent(x + i, y + j)) return true;
                    }
                }
            }
        }
        return false;
    };

    // const zoom = window.imageEditor.store.canvas.getZoom();
    // strokeWidth = strokeWidth * zoom;

    ctx.fillStyle = 'white';
    for (let y = 0; y < imageData.height; y++) {
        for (let x = 0; x < imageData.width; x++) {
            if (isEdgePixel(x, y)) {
                drawTransparentPoint(ctx, x, y, strokeWidth);
            }
        }
    }
}

export function drawTransparentPoint(ctx, x, y, radius) {
    // Create a radial gradient
    const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);

    // Add color stops (0: center, 1: outer edge)
    gradient.addColorStop(0, `rgba(255, 255, 255, 1)`);   // Center: red with full opacity
    gradient.addColorStop(0.7, `rgba(255, 255, 255, 1)`);
    gradient.addColorStop(1, `rgba(255, 255, 255, 0)`);   // Edge: red with 0 opacity

    // Draw the point using the gradient
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, 2 * Math.PI, false);
    ctx.fillStyle = gradient;
    ctx.fill();
}
